module.exports = __webpack_public_path__ + "img/designer_intro.c2e36976.png";